class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
   
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
// console.log(parsedState);
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          // console.log(parsedState.sections[section.section]);
        }));

        // custom code to check if free gift is added to cart or not START
           ensureProductsInCart_cartjs(40355229073457, 40532562051121);
        // custom code to check if free gift is added to cart or not END


        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
     
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};




// ##################################### AUTO ADD PRDOCT GIF#########################




function ensureProductsInCart_cartjs(giftId1, giftId2) {
  $.getJSON('/cart.js', function (cart) {
    const giftIds = [giftId1, giftId2];
    const giftsInCart = cart.items.filter(item => giftIds.includes(item.id));
    const nonGiftItems = cart.items.filter(item => !giftIds.includes(item.id));

    // 🧩 CASE 1: Only gifts in cart → remove by key
    if (nonGiftItems.length === 0 && giftsInCart.length > 0) {
      console.log("❌ Only gifts in cart — removing by key...");

      giftsInCart.forEach(gift => {
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: JSON.stringify({ id: gift.key, quantity: 0 }),
          dataType: 'json',
          contentType: 'application/json',
          success: function () {
            console.log(`🗑️ Removed gift: ${gift.title} (key: ${gift.key})`);
            refreshCartDrawer_cartjs();
          },
          error: function (xhr, status, error) {
            console.error('❌ Error removing gift:', gift.title, error);
          }
        });
      });
      return;
    }

    // 🧩 CASE 2: Regular items exist → ensure both gifts are in cart
    const productIdsInCart = cart.items.map(item => item.id);
    const toAdd = [];

    if (nonGiftItems.length > 0) {
      if (!productIdsInCart.includes(giftId1)) {
        toAdd.push({ id: giftId1, quantity: 1 });
      }
      if (!productIdsInCart.includes(giftId2)) {
        toAdd.push({ id: giftId2, quantity: 1 });
      }

      if (toAdd.length === 0) {
        console.log('✅ Both gifts already in cart');
        return;
      }

      console.log("🎁 Adding missing gifts:", toAdd);

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items: toAdd }),
        dataType: 'json',
        contentType: 'application/json',
        success: function () {
          console.log('✅ Added missing gifts to cart:', toAdd);
          refreshCartDrawer_cartjs();
        },
        error: function (xhr, status, error) {
          console.error('❌ Error adding gifts:', status, error);
        }
      });
    }
  });
}



function refreshCartDrawer_cartjs() {
  var currency =  $("body").attr("data-bodycurrency_symbol");
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (cartData) {
      console.log('🛒 Cart refreshed:', cartData);

      var sell_availeble = '';
      var htmlprod = '';
      var size_html = '';
      var table_start = '<div class="drawer__cart-items-wrapper"></div><table class="cart-items" role="table"><thead role="rowgroup"><tr role="row"><th id="CartDrawer-ColumnProductImage" role="columnheader"><span class="visually-hidden">Product image</span></th><th id="CartDrawer-ColumnProduct" class="caption-with-letter-spacing" scope="col" role="columnheader">Product</th><th id="CartDrawer-ColumnTotal" class="right caption-with-letter-spacing" scope="col" role="columnheader">Total</th><th id="CartDrawer-ColumnQuantity" role="columnheader"><span class="visually-hidden">Quantity</span></th></tr></thead><tbody role="rowgroup">';
      var table_end = '</tbody></table></div>';

      $.each(cartData.items, function (index, item) {
        index++;
        sell_availeble = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : '';
        size_html = item.variant_title ? '<dl><div class="product-option"><dt>Size: </dt><dd>' + item.variant_title + '</dd></div></dl>' : '';

        htmlprod += '<tr id="CartDrawer-Item-' + index + '" class="cart-item" role="row">' +
          '<td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage">' +
          '<a href="' + item.url + '" class="cart-item__link" tabindex="-1" aria-hidden="true"></a>' +
          '<img class="cart-item__image" src="' + item.image + '" alt="' + item.product_title + '" loading="lazy" width="150" height="184"></td>' +
          '<td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct">' +
          '<a href="' + item.url + '" class="cart-item__name h4 break">' + item.product_title + '</a>' +
          '<div class="product-option">' +currency + ' '+ parseFloat(item.final_price / 100).toFixed(2) + '</div>' +
          size_html + '<p class="product-option">' + sell_availeble + '</p></td>' +
          '<td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal">' +
          '<div class="cart-item__price-wrapper"><span class="price price--end">'+currency + ' '+ parseFloat((item.quantity) * (item.final_price / 100)).toFixed(2) + '</span></div></td>' +
          '<td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity">' +
          '<div class="cart-item__quantity-wrapper"><quantity-input class="quantity">' +
          '<input class="quantity__input" type="number" name="updates[]" value="' + item.quantity + '" min="0" aria-label="Quantity for ' + item.product_title + '" id="Drawer-quantity-' + index + '" data-index="' + index + '">' +
          '</quantity-input></div></td></tr>';
      });

      var finalHtml = table_start + htmlprod + table_end;
      var isCartEmpty = $(".drawer__inner-empty").length;

      if (isCartEmpty > 0) {
        $('#CartDrawer-CartItems').html(finalHtml);
        $(".drawer__inner-empty").remove();
        $("cart-drawer").removeClass("is-empty").addClass("active");
        $("cart-drawer-items").removeClass("is-empty");
        console.log("🆕 Empty cart filled");
      } else {
        console.log("🔄 Updated cart");
        $('.cart-items tbody').html(htmlprod);
        $(".drawer__inner-empty").remove();
        $("cart-drawer").removeClass("is-empty").addClass("active");
        $("cart-drawer-items").removeClass("is-empty");
      }

      $(".cart-drawer__footer .totals__subtotal-value").text(currency + ' ' + parseFloat(cartData.total_price / 100).toFixed(2));
      $(".drawer__header .items-count").text(cartData.item_count + ' items');
      $('.cart-count-bubble span:first').text(cartData.item_count);
      $(".add_btn .loading-overlay__spinner").addClass("hidden");
      $('#CartDrawer-Checkout').removeAttr('disabled');
    },
    error: function (xhr, status, error) {
      console.error('Error fetching cart data:', status, error);
      $(".add_btn .loading-overlay__spinner").addClass("hidden");
    }
  });
}